module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0016.0068e842.jpg";